import React from 'react';
import { CountBox } from './CountBox';

const CountBar = ({ activeNodes, inactiveNodes, accounts, locations }: Props) => {
  return (
    <div className="row gy-4 gy-sm-1">
      <div className="col-sm-6 col-lg-3">
        <CountBox title="Licensed nodes" count={activeNodes} icon="ti-certificate-2" color="bg-label-primary" />
        <hr className="d-none d-sm-block d-lg-none me-4" />
      </div>
      <div className="col-sm-6 col-lg-3">
        <CountBox title="Unlicensed nodes" count={inactiveNodes} icon="ti-certificate-2-off" color="bg-label-secondary" />
        <hr className="d-none d-sm-block d-lg-none" />
      </div>
      <div className="col-sm-6 col-lg-3">
        <CountBox title="Accounts" count={accounts} icon="ti-layout-grid" color="bg-label-danger" />
      </div>
      <div className="col-sm-6 col-lg-3">
        <CountBox title="Locations" count={locations} icon="ti-location" color="bg-label-primary" />
      </div>
    </div>
  );
}

interface Props {
  activeNodes: number,
  inactiveNodes: number,
  accounts: number,
  locations: number
}

export { CountBar };